<template>
  <div class="top-page">
    <live-program-button class="live-program-button" v-if="hasLiveList" />
    <span class="ribbon" aria-hidden />
    <first-visual />
    <main class="main-area">
      <div class="sticky">
        <a class="logo" href="#" v-scroll-to="'body'"><img src="@/assets/img/logo.svg"/></a>
      </div>
      <whats-this />
      <howto-join />
      <!-- 注意事項を戻す際は PR # 参考 -->
      <p class="copyright">&copy; DWANGO Co., Ltd.</p>
    </main>
  </div>
</template>

<script>
import FirstVisual from '../sections/FirstVisual';
import WhatsThis from '../sections/WhatsThis';
import HowtoJoin from '../sections/HowtoJoin';
import LiveProgramButton from '../atoms/LiveProgramButton';

export default {
  name: 'top',
  components: {
    FirstVisual,
    WhatsThis,
    HowtoJoin,
    LiveProgramButton,
  },
  computed: {
    hasLiveList() {
      return this.$store.getters['live/hasLiveList'];
    },
  },
  mounted() {
    this.$store.dispatch('live/getLive');
  },
};
</script>

<style lang="scss" scoped>
@import '../../constants/style';

.top-page {
  /* iOS で copyright の margin-bottom が消えるので必要 */
  padding-bottom: 1px;
}

.live-program-button {
  margin-left: auto;
  position: absolute;
  top: 24px;
  right: 24px;
  z-index: 9999;
}

.ribbon {
  background: linear-gradient(
    to right,
    var(--color-red) 0%,
    var(--color-red) 20%,
    var(--color-gray) 20%,
    var(--color-gray) 40%,
    var(--color-green) 40%,
    var(--color-green) 60%,
    var(--color-yellow) 60%,
    var(--color-yellow) 80%,
    var(--color-blue) 80%,
    var(--color-blue) 100%
  );
  display: block;
  height: 6px;
  position: sticky;
  top: 0;
  width: 100%;
  z-index: 9999;
}

.main-area {
  position: relative;

  > .sticky {
    align-items: flex-start;
    display: flex;
    justify-content: space-between;
    height: 120px;
    margin-bottom: -120px;
    position: sticky;
    top: 0;
    pointer-events: none;
    width: 100%;
    z-index: 99999;

    > * {
      pointer-events: all;
    }

    > .logo {
      display: block;
      margin-top: 32px;
      margin-left: 32px;
      position: sticky;
      width: 224px;

      > img {
        height: auto;
        max-width: 100%;
      }

      > .button {
        margin-right: 24px;
      }
    }

    > .check {
      margin-top: 0;
      margin-right: 16px;
    }
  }

  > .copyright {
    font-weight: normal;
    font-size: 12px;
    line-height: 100%;
    color: #343438;
    margin: 100px auto 24px;
    text-align: center;
  }
}

@media #{$mq-sp} {
  .live-program-button {
    display: none;
  }

  .main-area {
    > .sticky {
      > .logo {
        display: none;
      }

      > .check {
        margin: 0;
        position: fixed;
        bottom: 0;
        left: 0;
        width: 100%;
      }
    }

    > .copyright {
      margin: 48px auto 160px;
    }
  }
}
</style>
